"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lendingPool_1 = __importDefault(require("./lendingPool"));
const simple_uniswap_oracles_1 = require("../../config/contracts/simple-uniswap-oracles");
const routers_1 = require("../../config/contracts/routers");
class OnchainImpermaxFactory {
    constructor(router, factory) {
        this.cache = {};
        this.getOnchain = () => this.onchain;
        this.getFactory = () => this.factory;
        this.onchain = router;
        this.factory = factory;
        this.lendingPools = {};
    }
    cleanCache() {
        this.cache = {};
        for (const pairAddress of Object.keys(this.lendingPools)) {
            this.lendingPools[pairAddress].cleanCache();
        }
    }
    getSimpleUniswapOracle() {
        if (!this.cache.simpleUniswapOracleContract) {
            const address = simple_uniswap_oracles_1.SIMPLE_UNISWAP_ORACLE[this.onchain.network][this.factory];
            if (!address) {
                console.error("SimpleUniswapOracle address not found");
                return null;
            }
            this.cache.simpleUniswapOracleContract = this.onchain.getContractHelper().newSimpleUniswapOracle(address);
        }
        return this.cache.simpleUniswapOracleContract;
    }
    getRouter() {
        if (!this.cache.routerContract) {
            const address = routers_1.ROUTER[this.onchain.network][this.factory];
            if (!address) {
                console.error("Router address not found");
                return null;
            }
            this.cache.routerContract = this.onchain.getContractHelper().newRouter(address);
        }
        return this.cache.routerContract;
    }
    getLendingPool(uniswapV2PairAddress) {
        if (!this.lendingPools[uniswapV2PairAddress])
            this.lendingPools[uniswapV2PairAddress] = new lendingPool_1.default(this, uniswapV2PairAddress);
        return this.lendingPools[uniswapV2PairAddress];
    }
}
exports.default = OnchainImpermaxFactory;
